<script setup lang="ts">
import clsx from 'clsx';

const props = defineProps<{ class?: string }>();
const classes = clsx('flex flex-1 items-center gap-4 py-2.5', props.class);
</script>

<template>
  <nav :class="classes"><slot /></nav>
</template>
